import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractFormulaToken from "./AbstractFormulaToken.js";

/**
 * Token representing a closing parenthesis.
 *
 * Parenthesis are used when parsing a list of tokens to determine operator
 * precedence.
 */
export default class ClosingParenthesisFormulaToken extends AbstractFormulaToken {
	isClosingParenthesis() {
		return true;
	}

	accept(visitor) {
		return visitor.visitClosingParenthesisFormulaToken(this);
	}

	static getLabel() {
		return _("Closing parenthesis");
	}

	static getType() {
		return "closing-parenthesis";
	}
}
